var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid foot__admon py-4"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 text-center"},[_vm._v(" © Desarrollado por "),_c('a',{attrs:{"href":"https://kiritek.com/","target":"_blank"}},[_vm._v("Kiritek")])])])])
}]

export { render, staticRenderFns }